import { useState } from "react";

import "./Hero.css";
import bannerImage from "../../assets/training-hero.png";
import bannerVideo from "../../assets/training-skyline.mp4";

function Hero({
  courseCount,
  searchInput,
  searchTerm,
  onSearchInputChange,
  onSearch,
  onClearSearch,
  onSearchKeyDown,
}) {
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <section className="hero" style={{ backgroundImage: `url(${bannerImage})` }}>
      <video
        className={`hero-video ${videoLoaded ? "show-video" : ""}`}
        src={bannerVideo}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={bannerImage}
        onLoadedData={() => setVideoLoaded(true)}
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="eyebrow">International Professional Training</p>
        <h1>Search Professional IT, AI, Data, Business and Corporate Training</h1>
        <p className="hero-text">
          Explore 1000+ professional training courses designed to help teams
          improve productivity, technical capability, compliance, digital
          transformation, and workplace performance.
        </p>

        <div className="hero-search">
          <input
            type="text"
            placeholder="Search courses like Angular, Power BI, SQL, ISO, Cybersecurity..."
            value={searchInput}
            onChange={(e) => onSearchInputChange(e.target.value)}
            onKeyDown={onSearchKeyDown}
          />
          <button type="button" onClick={onSearch}>
            Search
          </button>
          {searchTerm && (
            <button type="button" onClick={onClearSearch}>
              Clear
            </button>
          )}
        </div>
      </div>

      <aside className="hero-card marketing-card" id="why-trainosys">
        <h2>Why Train with Trainosys?</h2>
        <p>
          Trainosys helps organizations turn learning into measurable business
          capability through practical, instructor-led, and outcome-focused
          training programs.
        </p>
        <ul>
          <li>Improve employee productivity and confidence</li>
          <li>Close technical and business skills gaps</li>
          <li>Support digital transformation initiatives</li>
          <li>Prepare teams for modern tools, workflows, and compliance</li>
          <li>Flexible corporate, public, remote, onsite, or hybrid delivery</li>
        </ul>
      </aside>
    </section>
  );
}

export default Hero;
